// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

// Utils
import logger from '../../logger/logger';
import { selectStep } from './onboardingUtil';

// Services
import preloadOnboardingSteps from './config/preloadOnboardingSteps';

// Selectors
import { onboardingMetadataSelector, onboardingRouteFlowIdSelector } from './onboardingSelector';

// Actions
import { onboardingGotoStep } from './onboardingActions';

const mapStateToProps = createStructuredSelector({
    onboardingFlowId: onboardingRouteFlowIdSelector,
    onboardingQuery: onboardingMetadataSelector,
});

const mapDispatchToProps = (dispatch) => ({
    dispatchSelectStep: (stepId) => dispatch((_, getState) => selectStep(stepId, {}, getState())),
    dispatchGotoStep: (step, meta) => dispatch(onboardingGotoStep(step, meta)),
    dispatchPreloadSteps: () => dispatch(preloadOnboardingSteps()),
});

/**
 * This component is used to allow on-boarding flows to be initiated from URL query parameters.
 * E.g. This is used when an unregistered user is invited to a board - the board can be loaded, but then
 * an on-boarding flow is initiated to show the registration modal.
 */
const WorkspaceOnboardingUrlHandler = (props) => {
    const { onboardingFlowId, onboardingQuery, dispatchPreloadSteps, dispatchGotoStep, dispatchSelectStep } = props;

    // Very similar to OnboardingUrlRedirect
    React.useEffect(() => {
        if (!onboardingFlowId) return;

        dispatchPreloadSteps().then(() => {
            if (!dispatchSelectStep(onboardingFlowId)) {
                logger.warn('Unable to find onboarding step', onboardingFlowId);
                return;
            }

            dispatchGotoStep(onboardingFlowId, onboardingQuery);
        });
    }, []);

    return null;
};

WorkspaceOnboardingUrlHandler.propTypes = {
    onboardingFlowId: PropTypes.string,
    onboardingQuery: PropTypes.object,

    dispatchSelectStep: PropTypes.func,
    dispatchGotoStep: PropTypes.func,
    dispatchPreloadSteps: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceOnboardingUrlHandler);
